import { DISC_LETTER_NUMBER } from '../constants/apiConstants';

/**
 * Converts number to letter sequence using elegant base-26 approach.
 * 0->A, 25->Z, 26->AA, 27->AB, etc.
 *
 * This works like base-26 but with 1-based indexing (A=1, B=2, ..., Z=26)
 * instead of 0-based indexing.
 */
export function numberToLetters(n: number): string {
  if (n < 0) {
    return numberToLetters(n * -1);
  }
  if (n > DISC_LETTER_NUMBER) {
    throw new Error(`Number must be less than ${DISC_LETTER_NUMBER}`);
  }

  let result = '';
  // Add 1 to convert from 0-based to 1-based indexing
  n += 1;

  while (n > 0) {
    // Subtract 1 to handle the fact that there's no "zero" character
    n -= 1;
    // Get the rightmost "digit" in base-26
    result = String.fromCharCode(65 + (n % 26)) + result;
    // Move to the next position
    n = Math.floor(n / 26);
  }

  return result;
}

/**
 * Converts letter sequence back to number.
 * Case-insensitive.
 */
export function lettersToNumber(letters: string): number {
  if (!letters) {
    throw new Error('Input cannot be empty');
  }

  const upperLetters = letters.toUpperCase();
  if (!/^[A-Z]+$/.test(upperLetters)) {
    throw new Error('Input must contain only letters A-Z');
  }

  let result = 0;
  for (const char of upperLetters) {
    // Convert to 1-based value (A=1, B=2, ..., Z=26)
    result = result * 26 + (char.charCodeAt(0) - 65 + 1);
  }

  // Convert back to 0-based indexing
  return result - 1;
}
